import { render, staticRenderFns } from "./WorkflowEditor.vue?vue&type=template&id=64ec3caa"
import script from "./WorkflowEditor.vue?vue&type=script&lang=js"
export * from "./WorkflowEditor.vue?vue&type=script&lang=js"
import style0 from "./WorkflowEditor.vue?vue&type=style&index=0&id=64ec3caa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports